module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-classic-6-748ea1111df91687375f0b807cfb41e5.webp";